import {
  HOME_SAVE_PROJECT_ACTION_BEGIN,
  HOME_SAVE_PROJECT_ACTION_SUCCESS,
  HOME_SAVE_PROJECT_ACTION_FAILURE,
  HOME_SAVE_PROJECT_ACTION_DISMISS_ERROR,
} from './constants';

import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';
import {CREATE_PROJECT_MODEL_ACTION_CREATE} from '../../common/redux/constantes';



// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function saveProjectAction(project,scope,action,args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_SAVE_PROJECT_ACTION_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      // '{"project":{ "project":"0" ,"name":"proyecto Ejemplo", "description":"descripcion programa","start_planned_date":"2018-06-06", "duration": "90", "start_real_date":"2018-06-06","program":"1"}}' 
      
      // project.program = 1;

      let URL = SERVER_PATH + '/projects';
      let URLScope = SERVER_PATH + '/scopes';
      if(action === CREATE_PROJECT_MODEL_ACTION_CREATE){
        project.project = 0;
        scope.scope= 0;
        URL+="/create";
        URLScope+="/create"
      }else{
        URL+="/edit";
        URLScope+="/edit";
      }

      axios.post(URL, {
        project:project
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          if(res.data.success ===1){
            if(action === CREATE_PROJECT_MODEL_ACTION_CREATE){
              scope.project = res.data.projects.insertId;
            }
            /** EMPIEZA CREAR SCOPE**/
            axios.post(URLScope, {
              scope:scope
            }, AXIOS_CONFIG())
            .then(
              (res) => {
                if(res.data.success ===1){

                }else{
                  dispatch({
                    type: HOME_SAVE_PROJECT_ACTION_FAILURE,
                    data: { error: "Error" },
                  });
                  reject("Error");
                }
              },
              // Use rejectHandler as the second argument so that render errors won't be caught.
              (err) => {
                dispatch({
                  type: HOME_SAVE_PROJECT_ACTION_FAILURE,
                  data: { error: err },
                });
                reject(err);
              },
            );
            /** TERMINA CREAR SCOPE**/
            
            dispatch({
              type: HOME_SAVE_PROJECT_ACTION_SUCCESS,
              data: res.data,
              action_model:action
            });
            resolve(res);
          }else if(res.data.success ===-1){
            dispatch({
              type: HOME_SAVE_PROJECT_ACTION_FAILURE,
              data: { error: -1 },
              action_model:action
            });
            reject("Error");
          }else{
             dispatch({
              type: HOME_SAVE_PROJECT_ACTION_FAILURE,
              data: { error: "Error" },
            });
            reject("Error");
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_SAVE_PROJECT_ACTION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSaveProjectActionError() {
  return {
    type: HOME_SAVE_PROJECT_ACTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SAVE_PROJECT_ACTION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        savePending:true,
        saveProjectActionPending: true,
        saveProjectActionError: null,
      };

    case HOME_SAVE_PROJECT_ACTION_SUCCESS:
      // The request is success
      let fragmentContent = "The project has been updated with success!";
      let fragmentTitle = "Update Project";
      let paperTitle = "Update Project";
      if(action.action_model === CREATE_PROJECT_MODEL_ACTION_CREATE){

        fragmentContent='The project has been created with success!'
        fragmentTitle='Create Project'
        paperTitle='Create Project'
      }
      return {
        ...state,
        savePending:false,
        fragmentContent:fragmentContent,
        fragmentTitle:fragmentTitle,
        paperTitle:paperTitle,
        saveProjectActionPending: false,
        saveProjectActionError: null,
      };

    case HOME_SAVE_PROJECT_ACTION_FAILURE:
      // The request is failed
      let fragmentContentFail = "We found an error";
      let fragmentTitleFail = "Update Project";
      let paperTitleFail = "Update Project";
      if(action.action_model === CREATE_PROJECT_MODEL_ACTION_CREATE){

        fragmentContentFail='The project has not been created with success!'
        fragmentTitleFail='Create Project'
        paperTitleFail='Create Project'
        if(action.data && action.data.error === -1)
        {
          fragmentContentFail='You have reached the projects limit, please update your account'
        }
      }
      return {
        ...state,
        savePending:false,
        fragmentContent:fragmentContentFail,
        fragmentTitle:fragmentTitleFail,
        paperTitle:paperTitleFail,
        saveProjectActionPending: false,
        saveProjectActionError: action.data.error,
      };

    case HOME_SAVE_PROJECT_ACTION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        saveProjectActionError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/saveProjectAction.js